/* Keep autoplaying product-gallery videos playing while visible.
   Browsers suspend offscreen muted autoplay videos and do not resume
   them when they scroll back into view or their slide activates. */
(function () {
  if (!('IntersectionObserver' in window)) return;

  function tryPlay(video) {
    if (!video.paused || video.ended) return;
    var p = video.play();
    if (p) p.catch(function () {});
  }

  function inView(el) {
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight;
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          tryPlay(video);
        } else if (!video.paused) {
          video.pause();
        }
      });
    },
    { threshold: 0.1 }
  );

  // The hero sizes itself to its video's real ratio (see gb-custom.css) so the
  // whole video is visible instead of being cropped to a fixed section height.
  // Mobile and desktop carry different videos, so each gets its own ratio.
  function fitHero(wrapperClass, customProperty, flag) {
    document.querySelectorAll('.hero .' + wrapperClass + ' video').forEach(function (v) {
      var hero = v.closest('.hero');
      if (!hero || hero.dataset[flag]) return;
      var apply = function () {
        if (v.videoWidth && v.videoHeight) {
          hero.dataset[flag] = '1';
          hero.style.setProperty(customProperty, v.videoWidth + ' / ' + v.videoHeight);
        }
      };
      if (v.readyState >= 1) {
        apply();
      } else {
        v.addEventListener('loadedmetadata', apply, { once: true });
      }
    });
  }

  function fitHeroes() {
    fitHero('hero__media-wrapper--mobile', '--gb-hero-mobile-ratio', 'gbHeroFit');
    fitHero('hero__media-wrapper--desktop', '--gb-hero-desktop-ratio', 'gbHeroFitDesktop');
  }

  // PDP mobile gallery: show the per-image model-size caption next to the slide
  // counter. Captions live on each slide's .product-media[data-gb-caption]
  // (populated from the gb.model_sizes metafield); we mirror the active slide's
  // into a span appended alongside the counter.
  function initModelCaptions() {
    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      if (gallery.dataset.gbCaption) return;
      var counter = gallery.querySelector('slideshow-controls .slideshow-controls__counter');
      if (!counter) return;
      // Only wire up galleries that actually have at least one caption.
      if (!gallery.querySelector('.product-media[data-gb-caption]')) return;
      gallery.dataset.gbCaption = '1';

      var caption = document.createElement('span');
      caption.className = 'gb-model-caption';
      caption.setAttribute('data-empty', '');
      counter.closest('slideshow-controls').appendChild(caption);

      var scope = gallery.querySelector('slideshow-component') || gallery;
      var update = function () {
        var active = gallery.querySelector('slideshow-slide[aria-hidden="false"] .product-media[data-gb-caption]');
        var text = active ? active.getAttribute('data-gb-caption') || '' : '';
        caption.textContent = text;
        if (text) {
          caption.removeAttribute('data-empty');
        } else {
          caption.setAttribute('data-empty', '');
        }
      };
      new MutationObserver(update).observe(scope, {
        attributes: true,
        attributeFilter: ['aria-hidden'],
        subtree: true,
      });
      update();
    });
  }

  function scan() {
    fitHeroes();
    initModelCaptions();
    document.querySelectorAll('.product-media deferred-media[autoplay] video').forEach(function (v) {
      if (v.dataset.gbIo) return;
      v.dataset.gbIo = '1';
      v.muted = true;
      io.observe(v);
      // The browser (or another component) can pause a visible looping video;
      // resume unless it left the viewport.
      v.addEventListener('pause', function () {
        setTimeout(function () {
          if (inView(v)) tryPlay(v);
        }, 250);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });

  // Slides/grid items with content-visibility report 0x0 while skipped, so the
  // IntersectionObserver never fires for them; nudge visible videos on scroll.
  // Capture phase: the theme scrolls an inner .page-wrapper, not the window.
  var scrollTick = false;
  document.addEventListener(
    'scroll',
    function () {
      if (scrollTick) return;
      scrollTick = true;
      setTimeout(function () {
        scrollTick = false;
        document.querySelectorAll('.product-media deferred-media[autoplay] video[data-gb-io]').forEach(function (v) {
          if (inView(v)) tryPlay(v);
        });
      }, 300);
    },
    { passive: true, capture: true }
  );
})();

